/* eslint-disable @typescript-eslint/no-explicit-any */
// import { CheckoutRootVo } from "./checkout.interface";
import newColorAxiosInstance from "@/common-components-src/api/new-color-axiosInstance";

interface Data {
  data: any;
  code: string;
  msg: string;
}

// 查询优惠券列表
export const fetchCouponDetail = (params: any): Promise<any> => {
  // 原se_getCashCouponsNew
  return (
    newColorAxiosInstance
      // .post<any>(`se_getCashCouponsNew`, {}, { params: { body: JSON.stringify(requestData) } })
      .post<any>("trade_checkout_getCoupons", undefined, { params })
      .then((response: any) => response.data)
  );
};

// 单个 选中 取消优惠券
export const fetchOrCancelCoupon = (params: any): Promise<any> => {
  // 原se_useOrCancelCoupon
  return newColorAxiosInstance
    .post<Data>(`trade_checkout_toggleCoupons`, undefined, { params })
    .then((response: any) => response.data);
};

// 批量 选中 取消优惠券
export const fetchOrCancelCouponMount = (params: any): Promise<any> => {
  // 原se_reSetAllCoupons
  return newColorAxiosInstance
    .post<any>("trade_checkout_reselectCoupons", undefined, { params })
    .then((response: any) => response.data);
};

// 查询口令券
export const fetchPromocodeDetail = (requestData: any): Promise<any> => {
  // 原marketing_promocode_detail
  return (
    newColorAxiosInstance
      // .get<any>(`marketing_promocode_detail?promoCode=${requestData}`)
      .post<any>("marketing_activity_getCouponCode", undefined, {
        params: requestData,
      })
      .then((response: any) => response.data)
  );
};

// 选中 取消口令券
export const fetchuseOrCancelCouponCode = (params: any): Promise<any> => {
  // 原se_useOrCancelCouponCode
  return newColorAxiosInstance
    .post<any>(`trade_checkout_exchangeCouponCode`, undefined, { params })
    .then((response: any) => response.data);
};
